import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    labelStyle: {
        "&.Mui-focused": {
            display: "none",
        },
        "&.MuiFormLabel-root": {
            fontSize: theme.typography.subtitle2.fontSize,
            fontFamily: theme.typography.subtitle2.fontFamily,
            color: theme.palette.error.main,
            fontStyle: "italic",
        },
    },
    select: {
        "&.MuiInputBase-root .MuiSelect-select": {
            width: "120px",
            whiteSpace: "normal",
            fontSize: theme.typography.subtitle2.fontSize,
            fontFamily: theme.typography.subtitle2.fontFamily,
            color: theme.palette.text.primary,
        },
    },
    menuItem: {
        "&.MuiButtonBase-root": {
            fontSize: theme.typography.subtitle2.fontSize,
            fontFamily: theme.typography.subtitle2.fontFamily,
            color: theme.palette.text.primary,
        },
    },
}));
